import React from "react";

import {
  COLUMNELEMENT,
  CONCEPTS,
  CONTACTFORM,
  COOKIEELEMENT,
  COUNTINGNUMBERSBLOCK,
  CTABLOCK,
  EMPLOYEELISTBLOCK,
  FAQBLOCK,
  HOTELBOOKINGBLOCK,
  IMAGEBLOCK,
  IMAGELISTBLOCK,
  INFOBLOCK,
  LINKLISTELEMENT,
  LISTELEMENT,
  MAILINGLISTBLOCK,
  MAPBLOCK,
  PAGEPUFF,
  PARALLAXBLOCK,
  QUOTATIONBLOCK,
  QUOTATIONLISTBLOCK,
  ROUNDEDBLOCK,
  SCRIPTBLOCK,
  SERVICES,
  SLIDESHOW,
  STARTPAGEPUFFCONTAINER,
  TEXTBLOCK,
  TWOCOLUMNBLOCK,
  VIDEOBLOCK,
  SERVICEPACKAGESBLOCK,
  HTMLBLOCK
} from "Consts/blockTypes";
import {
  ArticleBlock,
  ColumnBlock,
  Concepts,
  ContactForm,
  CountingNumbersBlock,
  CTABlock,
  EmployeeListBlock,
  FAQBlock,
  HotelBookingBlock,
  ImageBlock,
  ImageListBlock,
  InfoBlock,
  LinkListElement,
  MailingListBlock,
  MapBlock,
  PagePuff,
  ParallaxBlock,
  QuotationBlock,
  QuotationListBlock,
  RoundedBlock,
  ScriptBlock,
  Services,
  SlideShow,
  StartPagePuffs,
  TextBlock,
  TwoColumnBlock,
  VideoBlock,
  ServicePackages,
  HtmlBlock
} from "Blocks";
import {CookieBlock} from "Components/Cookie/CookieBlock";

const MapBlocksToComponents = (blocks, NarrowText, PageCenterContent, showHero) => {
  let blocksToReturn = [];
  blocks.map((block, i) => {
    let firstVideo = block.Alias === VIDEOBLOCK && i === 0;
    let component = GetBlock(block, i, NarrowText, PageCenterContent, showHero, firstVideo);
    if (component !== undefined) {
      blocksToReturn.push(component);
    }
  });
  return blocksToReturn;
};

let GetBlock = (model, i, NarrowText, PageCenterContent, showHero, firstVideo) => {
  const {Alias} = model;
  switch (Alias) {
    case HTMLBLOCK:
      return <HtmlBlock {...model} key={`block-${i}`}/>;
    case IMAGELISTBLOCK:
      return <ImageListBlock {...model} key={`block-${i}`}/>;
    case COLUMNELEMENT:
      return <ColumnBlock {...model} key={`block-${i}`}/>;
    case TWOCOLUMNBLOCK:
      return <TwoColumnBlock {...model} key={`block-${i}`}/>;
    case PAGEPUFF:
      return (
        <PagePuff
          {...model}
          key={`block-${i}`}
          ImgToTheLeft={model.ImageToTheLeft}
          className="pagePuff"
        />
      );
    case LISTELEMENT:
      return <ArticleBlock {...model} key={`block-${i}`}/>;
    case MAPBLOCK:
      return <MapBlock {...model} key={`block-${i}`}/>;
    case COOKIEELEMENT:
      return <CookieBlock {...model} key={`block-${i}`} first={i == 0}/>;
    case CONCEPTS:
      return <Concepts {...model} key={`block-${i}`}/>;
    case SERVICES:
      return <Services {...model} key={`block-${i}`}/>;
    case QUOTATIONBLOCK:
      return <QuotationBlock {...model} key={`block-${i}`}/>;
    case QUOTATIONLISTBLOCK:
      return <QuotationListBlock Items={model.Items} key={`block-${i}`}/>;
    case PARALLAXBLOCK:
      return <ParallaxBlock {...model} key={`block-${i}`}/>;
    case EMPLOYEELISTBLOCK:
      return <EmployeeListBlock {...model} key={`block-${i}`}/>;
    case SLIDESHOW:
      return <SlideShow {...model} key={`block-${i}`}/>;
    case LINKLISTELEMENT:
      return <LinkListElement {...model} key={`block-${i}`}/>;
    case CONTACTFORM:
      return <ContactForm {...model} key={`block-${i}`}/>;
    case FAQBLOCK:
      return <FAQBlock {...model} key={`block-${i}`}/>;
    case INFOBLOCK:
      return <InfoBlock {...model} key={`block-${i}`}/>;
    case CTABLOCK:
      return <CTABlock {...model} key={`block-${i}`}/>;
    case SCRIPTBLOCK:
      return <ScriptBlock {...model} key={`block-${i}`}/>;
    case TEXTBLOCK:
      return (
        <TextBlock
          NarrowText={NarrowText}
          PageCenterContent={PageCenterContent}
          {...model}
          key={`block-${i}`}
        />
      );
    case STARTPAGEPUFFCONTAINER:
      return <StartPagePuffs {...model} key={`block-${i}`}/>;
    case VIDEOBLOCK:
      return <VideoBlock {...model} showHero={showHero} firstVideo={firstVideo} key={`block-${i}`}/>;
    case MAILINGLISTBLOCK:
      return <MailingListBlock {...model} key={`block-${i}`}/>;
    case IMAGEBLOCK:
      return (
        <ImageBlock
          NarrowText={NarrowText}
          PageCenterContent={PageCenterContent}
          {...model}
          key={`block-${i}`}
        />
      );
    case HOTELBOOKINGBLOCK:
      return <HotelBookingBlock {...model} key={`block-${i}`}/>;
    case COUNTINGNUMBERSBLOCK:
      return <CountingNumbersBlock {...model} key={`block-${i}`}/>;
    case ROUNDEDBLOCK:
      return <RoundedBlock {...model} key={`block-${i}`}/>;
    case SERVICEPACKAGESBLOCK:
      return <ServicePackages {...model} key={`block-${i}`}/>;
    default:
      break;
  }
};

export default MapBlocksToComponents;
